<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    name="user-action"
                    pagination="server"
                    search>
                        <template #filters>
                            <user-action-log-filter v-on:filter="filter($event)"></user-action-log-filter>
                        </template>
                    </v-table>
                    
    </b-card>
</template>

<script>
import LogOperationsApi from '@/api/log-operations'
import UserActionLogFilter from './components/UserActionLogFilter.vue'
import {BCard} from 'bootstrap-vue'
export default {
    components:{
        BCard,
        UserActionLogFilter
    },
    data(){
        return{
            loading:false,
            fields:[
                { name:"İşlem Seviyesi",key:"UserActionLogLevel", thClass:"w-5",sortable:true,sortKey:'ActionLogLevel',tdClass:'text-nowrap'},
                { name:"İşlem Tarihi",key:"CreateTime", thClass:"w-10",tdClass:'text-nowrap',sortable:true},
                { name:"Aksiyon Adı",key:"UserActionName", thClass:"w-10",sortable:true,sortKey:'ActionName',tdClass:'text-nowrap'},
                { name:"İşlemi Yapan",key:"UserFullName", thClass:"w-10",tdClass:'text-nowrap',},
                { name:"Detay",key:"Detail", thClass:"w-65",tdClass:'text-nowrap',sortable:true},
                
            ],
            filterData:{
                ActionLogLevel:null,
                ActionName:null,
            },
        }
    },
    methods:{
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        provider(data){
            return LogOperationsApi.GetUserActionLogTable({
                ActionLogLevel:this.filterData.ActionLogLevel,
                ActionName:this.filterData.ActionName,
                PaginationRequestModel:data
            })
        }
    }
}
</script>

<style>

</style>